import { AppleIDAuthorizationResponse, AppleResponse } from '../types/frontendTypes';

export const appleLoginMobile = (): Promise<AppleResponse> => {
  return new Promise((resolve, reject) => {
    window.cordova.plugins.SignInWithApple.signin(
      { requestedScopes: [0, 1] },
      function (response: AppleResponse) {
        console.log('Apple response', response);
        resolve(response);
      },
      function (err: { error: string; code: string }) {
        console.error(err);
        reject(err);
      }
    );
  });
};

export interface AppleWebResult {
  token: string;
  userName: string;
}

const APPLE_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

const loadAppleSDK = (): Promise<void> => {
  if (window.AppleID) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${APPLE_SDK_URL}"]`);
    if (existing) {
      // Script tag exists but AppleID not yet defined — wait for it
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('Apple JS SDK failed to load')));
      return;
    }
    const script = document.createElement('script');
    script.src = APPLE_SDK_URL;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Apple JS SDK failed to load'));
    document.head.appendChild(script);
  });
};

export const appleLoginWeb = (): Promise<AppleWebResult> => {
  return loadAppleSDK().then(() => {
    window.AppleID.auth.init({
      clientId: window.runtimeConfig.APPLE_CLIENT_ID_WEB,
      scope: 'name email',
      redirectURI: window.runtimeConfig.APPLE_REDIRECT_URI,
      usePopup: true
    });

    return window.AppleID.auth.signIn().then((response: AppleIDAuthorizationResponse) => {
      console.log('Apple web response', response);
      const token = response.authorization.id_token;
      const firstName = response.user?.name?.firstName || '';
      const lastName = response.user?.name?.lastName || '';
      const userName = [firstName, lastName].filter(Boolean).join(' ');
      return { token, userName };
    });
  });
};
